"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_base_1 = require("native-base");
const data_1 = require("./graphing/data");
const Splash_1 = __importDefault(require("./Splash"));
const UI_1 = require("./UI");
const ClaimGraph = ({ claim = undefined, significance = undefined, size = 400, includeLabels = true, victory, getUIComponents, getImage, }) => {
    const { VictoryChart, VictoryGroup, VictoryPolarAxis, VictoryArea, VictoryLabel, } = victory;
    const graphFill = UI_1.backgroundSecondary;
    const { idiocy, spirit, reach } = claim || {};
    const data = significance && significance['spirit']
        ? [significance]
        : [{ spirit, idiocy, reach }];
    const graphData = (0, data_1.getGraphData)(data);
    const grid = includeLabels
        ? { stroke: 'grey', strokeWidth: 0.25, opacity: 0.5 }
        : { stroke: 'none' };
    const padding = includeLabels
        ? undefined
        : { top: 10, bottom: 10, right: 10, left: 10 };
    const domainPadding = includeLabels ? undefined : { x: 0 };
    const getLabels = () => {
        if (!includeLabels) {
            return graphData.keys.map((key, i) => {
                return (react_1.default.createElement(VictoryPolarAxis, { key: i, dependentAxis: true, style: {
                        axisLabel: { padding: 0, fontSize: 10 },
                        axis: { stroke: 'none' },
                        grid,
                    }, tickLabelComponent: react_1.default.createElement(VictoryLabel, { textAnchor: "start", verticalAnchor: () => 'start', labelPlacement: "vertical" }), labelPlacement: "vertical", axisValue: i + 1, label: (0, data_1.humanizeLabel)(key).substring(0, 1), tickFormat: (t) => '', tickValues: [0.5] }));
            });
        }
        return graphData.keys.map((key, i) => {
            return (react_1.default.createElement(VictoryPolarAxis, { key: i, dependentAxis: true, style: {
                    axisLabel: { padding: 10 },
                    axis: { stroke: 'none' },
                    grid,
                }, tickLabelComponent: react_1.default.createElement(VictoryLabel, { labelPlacement: "vertical" }), labelPlacement: "perpendicular", axisValue: i + 1, label: (0, data_1.humanizeLabel)(key), tickFormat: (t) => Math.ceil(t * 100), tickValues: [0.25, 0.5, 0.75] }));
        });
    };
    if (!graphData || !graphData.maxima || !graphData.data) {
        return (react_1.default.createElement(Splash_1.default, { spinner: true, getUIComponents: getUIComponents, getImage: getImage }));
    }
    return (react_1.default.createElement(native_base_1.Box, { w: `${size}px`, h: size },
        react_1.default.createElement(VictoryChart, { polar: true, startAngle: 340, endAngle: 700, domainPadding: domainPadding, padding: padding, width: size, height: size, domain: { y: [0, 1] } },
            react_1.default.createElement(VictoryGroup, { colorScale: [graphFill], style: { data: { fillOpacity: 0.5, strokeWidth: 1 } } }, graphData.data.map((data, i) => {
                return react_1.default.createElement(VictoryArea, { key: i, data: data });
            })),
            getLabels(),
            react_1.default.createElement(VictoryPolarAxis, { labelPlacement: "parallel", tickFormat: () => '', style: {
                    axis: { stroke: 'none' },
                    grid,
                } }))));
};
exports.default = ClaimGraph;
